import { render } from "./ReliefDeletedList.vue?vue&type=template&id=41cf34d1&scoped=true"
import script from "./ReliefDeletedList.vue?vue&type=script&lang=js"
export * from "./ReliefDeletedList.vue?vue&type=script&lang=js"

import "./ReliefDeletedList.vue?vue&type=style&index=0&id=41cf34d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cf34d1"]])

export default __exports__